import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import './AiWorkbench.scss';
import TextToImagePanel from './TextToImagePanel';
import ImageEditingPanel from './ImageEditingPanel';
import { CreditConfigProvider } from '../../contexts/CreditConfigContext';

const AiWorkbench = () => {
  const location = useLocation();
  const { t } = useI18n();
  const [mode, setMode] = useState('text-to-image'); // 'text-to-image' or 'image-to-image'

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const modeParam = urlParams.get('mode');
    if (modeParam === 'image-to-image' || modeParam === 'text-to-image') {
      setMode(modeParam);
    }
  }, [location.search]);

  return (
    <CreditConfigProvider>
      <div className="ai-workbench">
        <div className="workbench-header">
          <h1>{t('aiWorkbench.title')}</h1>
        <p>{t('aiWorkbench.subtitle')}</p>
        </div>
        <div className="mode-selector">
          <button
            className={`mode-btn ${mode === 'image-to-image' ? 'active' : ''}`}
            onClick={() => setMode('image-to-image')}
          >
            {t('aiWorkbench.imageToImage')}
          </button>
          <button
            className={`mode-btn ${mode === 'text-to-image' ? 'active' : ''}`}
            onClick={() => setMode('text-to-image')}
          >
            {t('aiWorkbench.textToImage')}
          </button>
        </div>
        <div className="workbench-body">
          {mode === 'text-to-image' ? <TextToImagePanel /> : <ImageEditingPanel />}
        </div>
      </div>
    </CreditConfigProvider>
  );
};

export default AiWorkbench;